import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-taupe/20 py-5" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-2">
        <span className="font-serif text-xl md:text-2xl text-marron-suave font-semibold group-hover:text-terracota transition-colors pr-4" data-id="element-3">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-4">
          <ChevronDown className="text-terracota w-6 h-6 flex-shrink-0" data-id="element-5" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-7">
            <p className="pt-4 pb-2 text-marron-suave/80 leading-relaxed text-lg" data-id="element-8">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}